const QUERY = '(hover: hover) and (pointer: fine)';

const updateDataset = (matches) => {
    document.documentElement.dataset.hoverSupported = String(matches);
};

const init = () => {
    const mediaQuery = window.matchMedia(QUERY);
    updateDataset(mediaQuery.matches);
    mediaQuery.addEventListener?.('change', (event) => updateDataset(event.matches));
};

export default { init };
